/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 确认收货
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/order/good-order/confirm-receipt/${orderId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
